import {
    Dialog,
    DialogActions,
    Typography,
    Button,
    Box,
    IconButton,
    Link
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/img/logo.png';

const DashboardPopup = ({ open, onClose }) => {
    const navigate = useNavigate();

    const handleFaqClick = () => {
        onClose();
        navigate('/faq');
    };

    return (
        <Dialog
            open={open}
            maxWidth="sm"
            fullWidth
            onClose={onClose}
            PaperProps={{
                sx: {
                    position: 'relative',
                    background: '#f5f5f5'
                }
            }}
        >
            <Box sx={{ p: 2, textAlign: 'center' }}>
                <img src={logo} alt="Total Turf Experience" style={{ width: '200px', marginBottom: '1rem' }} />
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8
                    }}
                >
                    <CloseIcon />
                </IconButton>
                
                <Typography variant="h5" gutterBottom sx={{ color: 'success.main' }}>
                    New Feature Alert!
                </Typography>
                
                <Typography paragraph>
                    We're excited to announce that you can now manage your children's accounts directly through the member portal!
                </Typography>

                <Typography paragraph>
                    <u>If you have children that enjoy TTE:</u>
                </Typography>

                <Typography component="div" sx={{ textAlign: 'left', mb: 2 }}>
                    <ul>
                        <li>Add your children to your account using the new Children page</li>
                        <li>Each child requires a player administrative fee</li>
                        <li>Children can be easily checked in using your Entry Pass</li>
                    </ul>
                </Typography>

                <Typography paragraph>
                    Click the "<b>Children</b>" link in the sidebar to get started, or visit our{' '}
                    <Link 
                        component="button"
                        onClick={handleFaqClick}
                    >
                        FAQ
                    </Link>
                    {' '}for more information.
                </Typography>

                <DialogActions sx={{ justifyContent: 'center', pt: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={onClose}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default DashboardPopup; 